import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router';
import { FlexBox } from '../layout';

interface SectionCardProps {
  title: React.ReactNode;
  icon: React.ReactNode;
  action: React.ReactNode;
  hasItems: boolean;
  to?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({
  title,
  icon,
  action,
  hasItems,
  to,
  onClick,
  children,
}) => (
  <FlexBox
    border={(theme) => `1px solid ${theme.palette.gray?.[300]}`}
    borderRadius={4}
    flexDirection="column"
  >
    {hasItems ? (
      <>
        <FlexBox
          borderBottom={(theme) => `1px solid ${theme.palette.gray?.[300]}`}
          px={3}
          py={1}
          alignItems="center"
          justifyContent="space-between"
        >
          <FlexBox gap={1} alignItems="center">
            <FlexBox
              alignItems="center"
              justifyContent="center"
              width={70}
              height={70}
            >
              {icon}
            </FlexBox>
            <Typography component={'div'} variant="h4">
              {title}
            </Typography>
          </FlexBox>
          {action}
        </FlexBox>
        <FlexBox flexDirection="column" p={3}>
          {children}
        </FlexBox>
      </>
    ) : (
      <FlexBox pl={2} pr={3} py={2} alignItems="center" gap={2}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 100,
            height: 100,
            textDecoration: 'none',
            color: 'inherit',
            cursor: 'pointer',
            userSelect: 'none',
          }}
          {...(to ? { component: Link, to } : { onClick })}
        >
          {icon}
        </Box>
        <Typography
          variant="h4"
          {...(to ? { component: Link, to } : { component: 'div', onClick })}
          sx={{
            flex: 1,
            textDecoration: 'none',
            color: 'inherit',
            cursor: 'pointer',
            userSelect: 'none',
          }}
        >
          {title}
        </Typography>
        {action}
      </FlexBox>
    )}
  </FlexBox>
);

export default SectionCard;
